export default "__VITE_ASSET__CC7XjXoo__"